import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from "react-bootstrap";
import { useDocumentUpload } from 'hooks/useDocumentUpload';
import CrossIcon from "assets/img/file-cut-icon.png";


export default function EditDocModal({ onHide, title, file, userId }) {
    const { handleViewFile, handleFileUpload } = useDocumentUpload({ candidateId: userId });

    const handleConfirmEdit = async () => {
        await handleFileUpload(title, file);
        onHide();
    }

    return (
        <Modal show={true} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>Confirm Edit</Modal.Title>
                <button onClick={onHide} className="modal-close">
                    <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
                </button>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to edit the document?
                <div className="file-name-view-container">
                    <p>{file.name}</p>
                    <button typ="button" className='btn-interactive text-info' 
                        onClick={() => handleViewFile(title)}>
                        View
                    </button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="cancel-cta"
                    style={{ color: "white" }}
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button
                    variant="update-cta"
                    style={{ backgroundColor: "red", color: "white" }}
                    onClick={handleConfirmEdit}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

EditDocModal.propTypes = {
    onHide: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    file: PropTypes.shape({
        name: PropTypes.string
    }).isRequired,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};